import React, { useRef, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import BTN from "../../../UI/Button/Button";
import { Tooltip } from "@material-ui/core";
import Fade from '@material-ui/core/Fade';
import Checkbox from "@material-ui/core/Checkbox";
import moment from "moment";
import DeleteIcon from "./DeleteIcon";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { AddToPhotosRounded, LaunchRounded } from "@material-ui/icons";
import { createSortHandler, getComparator, stableSort } from "../../utils";
import Grid from '@material-ui/core/Grid';
import classes from './ListOfCvs.module.css'
import commonClasses from '../../CVs.module.css'

import TablePagination from "@material-ui/core/TablePagination";
import { searchFileContentByFileId } from "../../../../graph-services/GraphServices";
import { TablePaginationActions } from '../../../UI/Table/TablePagination';
function Row(props) {
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('modificationDate');
    let [opportunityDetails, setOpportunityDetails] = useState(null);

    const handleChangePage = (event, newPage) => {
        props.setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        props.setRowsPerPage(parseInt(event.target.value, 10));
        props.setPage(0);
    };
    const formatDate = "YYYY-MM-DD HH:mm";
    const tableHeadCells = [
        {
            label: "Opportunity",
            id: "opportunityName",
            sort: "asc",
            width: "auto"

        },
        {
            label: "Client",
            id: "clientName",
            sort: "asc",
            width: "auto"
        },
        {
            label: "File Name",
            id: "name",
            sort: "asc",
            width: "15%"

        },
        {
            label: "Creation Date",
            id: "creationDate",
            sort: "asc",
            width: "auto"
        },
        {
            label: "Modification Date",
            id: "modificationDate",
            sort: "desc",
            width: "auto"
        },
        {
            label: "Last Modification User",
            id: "modificationUser",
            sort: "asc",
            width: "auto"
        },
    ]

    const checkItemExistence = (item, list) => {
        return list.some((state) => item === state.fileId);
    }

    const handleCheck = (event, fileName) => {
        let updatedList = [...props.checkedList];
        let file = { fileName: fileName, fileId: event.target.value }
        if (event.target.checked) {
            updatedList = [...props.checkedList, file];
        } else {
            const index = props.selectedItemIndex(props.checkedList, event.target.value)
            updatedList.splice(index, 1);
        }
        props.setCheckedList(updatedList);
    };

    const handleGetOpportunityDetail = async (id) => {
        setOpportunityDetails(null);
        setOpportunityDetails(await searchFileContentByFileId(props.access_token, props.siteId, id));
    }
    const getCommercialCvUserNameFromFile = (fileName) => {
        let indices = [];
        for (let i = 0; i < fileName.length; i++) {
            if (fileName[i] === "-") {
                indices.push(i);
            }
        }
        return (fileName.substring(indices[indices.length - 2] + 2))
    }

    const extractListOfCommercialCvs = () => {
        let listAllCvs = [];
        if(props.data.length>0){
            props.data.forEach((data) => {
                data.opportunities.forEach((opportunity) => {
                    opportunity.cvs.forEach((cv) => {
                        cv["details"] = opportunity.details
                        listAllCvs.push(cv)
                    })
                })
            })
        }
        return listAllCvs
    }


    const getOpportunityItemsPerCV = (row) => {
        return (
            [
                {
                    label: 'Opportunity Name :',
                    details: row.opportunityName
                },
                {
                    label: 'Manager :',
                    details: opportunityDetails?.content?.manager?.displayName?._text ?? "-"
                },
                {
                    label: 'Deadline :',
                    details: opportunityDetails?.content?.deadline?._text ?? "-"
                },
                {
                    label: 'Creation Date :',
                    details: moment(row.details.creationDate).format(formatDate)
                },
                {
                    label: 'Modification Date :',
                    details: moment(row.details.modificationDate).format(formatDate)
                },
                {
                    label: 'Modification User :',
                    details: row.details.modificationUser
                }
            ]
        )
    }

    const opportunityTooltip = (row) => {
        return (
            <div className={classes.opportunityTooltipContainer}>
                {opportunityDetails ? getOpportunityItemsPerCV(row).map((opportunity, index) =>
                    <Grid key={index} container spacing={2}>
                        <Grid item xs={6}>{opportunity.label}</Grid>
                        <Grid item xs={6}>{opportunity.details}</Grid>
                    </Grid>
                ) : <p>Loading...</p>}
            </div>
        )
    }

    let displayCommercialCvs =
        <Paper className={commonClasses.root}>
            {/* {props.data.length > 0 ? ( */}
                <TableContainer>
                    <Table size={"small"} stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {props.isVisibleSalesBtn ? (
                                    <TableCell width='10px'> </TableCell>
                                ) : null}
                                {tableHeadCells.map((cell, index) =>
                                    <TableCell
                                        width={cell.width}
                                        key={index}
                                        sortDirection={orderBy === cell.id ? order : false}
                                    >
                                        <TableSortLabel
                                            active={orderBy === cell.id}
                                            direction={orderBy === cell.id ? order : 'asc'}
                                            onClick={createSortHandler(cell.id, setOrder, setOrderBy, orderBy, order)}>
                                            {cell.label}
                                            {orderBy === cell.id ? (
                                                <span className={commonClasses.visuallyHidden}>
                                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                </span>
                                            ) : null}
                                        </TableSortLabel>
                                    </TableCell>
                                )}
                                <TableCell width="300px"> </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stableSort(extractListOfCommercialCvs(), getComparator(order, orderBy)).slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage).map((cv,index) =>
                                <TableRow hover role="checkbox" key={index}>
                                    {props.isVisibleSalesBtn ? (
                                        <TableCell style={{ padding: 0, width: '10px', margin: 0 }}>
                                            <div>
                                                <Checkbox
                                                    checked={checkItemExistence(cv.id, props.checkedList)}
                                                    value={cv.id}
                                                    onChange={(e) => handleCheck(e, cv.name)}
                                                    color="primary"
                                                />
                                            </div>
                                        </TableCell>
                                    ) : null}
                                    <TableCell align="left" className={classes.ellipsisCell}
                                        onClick={() => props.editFile(cv)}>
                                        <Tooltip title={opportunityTooltip(cv)} placement="right"
                                            classes={{ tooltip: classes.tooltipStyle }} TransitionComponent={Fade}
                                            arrow
                                            onOpen={() => handleGetOpportunityDetail(cv.details.id)}>
                                            <span>
                                                {cv.opportunityName}
                                            </span>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align="left" className={classes.ellipsisCell}
                                        onClick={() => props.editFile(cv)}>
                                        <span>
                                            {cv.clientName}
                                        </span>
                                    </TableCell>
                                    <TableCell align="left"
                                        className={`${classes.ellipsisCell} ${classes.ellipsisCellBefore}`}
                                        onClick={() => props.editFile(cv)}>
                                        <Tooltip title={cv.name.replace(".xml", "")} placement="top"
                                            classes={{ tooltip: classes.tooltipStyle }} TransitionComponent={Fade}
                                            arrow>
                                            <span>
                                                {getCommercialCvUserNameFromFile(cv.name.replace(".xml", ""))}
                                            </span>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align="left" onClick={() => props.editFile(cv)}>
                                        {moment(cv.creationDate).format(formatDate)}
                                    </TableCell>
                                    <TableCell align="left" onClick={() => props.editFile(cv)}>
                                        {moment(cv.modificationDate).format(formatDate)}
                                    </TableCell>
                                    <TableCell align="left" onClick={() => props.editFile(cv)}>
                                        {cv.modificationUser}
                                    </TableCell>
                                    <TableCell style={{ padding: 0, width: '300px', margin: 0 }}>
                                        <div className={commonClasses.actions}>
                                            {props.isVisibleSalesBtn &&
                                                <BTN label="CLONE COMMERCIAL CP"
                                                    variant="success"
                                                    size="sm"
                                                    isVisible={true}
                                                    actionHandler={() => props.cloneFile(cv)}
                                                    tooltip={`clone this Commercial Consultant Profile`}
                                                    icon={<AddToPhotosRounded />}
                                                    smallScreenThreshold={"66rem"}
                                                    style={{ width: "auto", marginLeft: "15px" }}
                                                />}
                                            <BTN label="OPEN"
                                                variant="success"
                                                size="sm"
                                                isVisible={true}
                                                actionHandler={() => props.editFile(cv)}
                                                tooltip={`open this Commercial Consultant Profile`}
                                                icon={<LaunchRounded />}
                                                smallScreenThreshold={"66rem"}
                                                style={{ width: "auto", marginLeft: "1%" }} />
                                            {props.isAdminMember &&
                                                <DeleteIcon
                                                    element={"Consultant Profile"}
                                                    elementName={cv.name.replace(".xml", "")}
                                                    delete={() => props.deleteCP(cv)}
                                                />}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            {/* ) : null} */}
            <TablePagination
                rowsPerPageOptions={[25, 50, 100]}
                component="div"
                count={extractListOfCommercialCvs()?.length}
                rowsPerPage={props.rowsPerPage}
                page={props.page}
                SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
            />
        </Paper>

    return (
        <>
            {displayCommercialCvs}
        </>
    );
}

export default function CollapsibleTable(props) {
    return <Aux> {<Collapsable {...props} />}</Aux>
}

let Collapsable = (props) => {
    return (
        <Row
            onLoading={props.onLoading}
            hidePopup={props.hidePopup}
            isOpenPopup={props.isOpenPopup}
            popupLauncher={props.popupLauncher}
            launchPopup={(e) => props.launchPopup(e)}
            lang={props.lang}
            isVisibleSalesBtn={props.isVisibleSalesBtn}
            isAdminMember={props.isAdminMember}
            editFile={(v) => props.editFile(v)}
            editOpportunity={(opportunity) => props.editOpportunity(opportunity)}
            deleteOpportunity={(opportunity) => props.deleteOpportunity(opportunity)}
            deleteCP={props.deleteCP}
            cloneFile={(v) => props.cloneFile(v)}
            checkedList={props.checkedList}
            setCheckedList={props.setCheckedList}
            selectedItemIndex={props.selectedItemIndex}
            data={props.data}
            setRowsPerPage={props.setRowsPerPage}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            setPage={props.setPage}
            access_token={props.access_token}
            siteId={props.siteId}
        />
    )
}